import styled from 'styled-components';


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  margin-right: 10px;
  margin-left: 10px;
  input::placeholder {
    color: white; /* Cor do texto do placeholder */
    opacity: 1; /* Garante que a cor seja aplicada corretamente */
 }
`;

export const Label = styled.label`
  margin-bottom: 8px;
  color: var(--text);
  font-size: 21px;
  text-align: left;
  font-family: "Montserrat";
`;

export const StyledInput = styled.input<{ isErrored: boolean }>`
  padding: 8px;
  border: 1px solid ${props => (props.isErrored ? 'red' : ' var(--text)')};
  border-radius: 16px;
  font-size: 21px;
  font-family: "Montserrat";
  color:  var(--setra-blue);

  
  &:focus {
    border-color: ${props => (props.isErrored ? 'red' : '#666')};
    outline: none;
  }
`;

export const StyledTextarea = styled.textarea<{ isErrored: boolean }>`
  padding: 8px;
  border: 1px solid ${props => (props.isErrored ? 'red' : ' var(--text)')};
  border-radius: 16px;
  font-size: 21px;
  font-family: "Montserrat";
  color:  var(--setra-blue);

  
  &:focus {
    border-color: ${props => (props.isErrored ? 'red' : '#666')};
    outline: none;
  }
`;

export const Error = styled.span`
  color: red;
  margin-top: 8px;
  font-size: 14px;
`;